module.exports = __webpack_public_path__ + "img/PT57.f03d455f.png";